import { FontFamilyByLanguageTheme } from '@kite-js/theme-types';
import families from './families';

const familiesByLanguage: FontFamilyByLanguageTheme[] = [
    {
        lang: '', // default
        families: [families.montserrat, families.helveticaNeue, families.helvetica, families.arial, families.sansSerif],
    },
    {
        lang: 'jp',
        families: [families.mallory, families.meiryo, families.hiragino, families.yuGothic, families.sansSerif],
    },
    { lang: 'ae', families: [families.tahoma, families.arial, families.helvetica, families.sansSerif] },
    {
        lang: 'hk',
        families: [families.mallory, families.pingFangTC, families.jhenghei, families.heiti, families.sansSerif],
    },
    {
        lang: 'tw',
        families: [families.mallory, families.pingFangTC, families.jhenghei, families.heiti, families.sansSerif],
    },
    {
        lang: 'cn',
        families: [families.mallory, families.pingFangSC, families.yahei, families.heiti, families.sansSerif],
    },
    {
        lang: 'kr',
        families: [
            families.mallory,
            families.msNeogothic,
            families.appleSdGothicNeo,
            families.malgun,
            families.sansSerif,
        ],
    },
    { lang: 'th', families: [families.mallory, families.thonburi, families.tahoma, families.sansSerif] },
];

export default familiesByLanguage;
